import React, { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { initializeAppScripts } from "../main";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleServicesClick = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      const servicesSection = document.getElementById("services");
      if (servicesSection) {
        servicesSection.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { targetId: "services" } });
    }
  };

  useEffect(() => {
    initializeAppScripts();
  }, []);

  return (
    <>
      <footer className="footer" id="footer">
        <div className="container">
          <div className="footer-container">
            <div className="footer-column">
              <div className="logo">
                <span className="circle blue">H</span>
                <span className="circle green">W</span>
                <span className="circle red">S</span>
              </div>
              <h2 className="company-name">
                Hope <span className="highlight">Web</span>{" "}
                <span className="highlight-red">Solutions</span>
              </h2>
              <p className="description">
                Hope Web Solutions delivers innovative mobile apps, web
                platforms, and AI-powered solutions tailored to your business
                needs. Our expert team ensures high-quality,
              </p>
              <div className="social-icons">
                <a href="#">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="512"
                    height="512"
                    viewBox="0 0 511 511.9"
                  >
                    <g>
                      <path
                        d="M510.95 150.5c-1.2-27.2-5.598-45.898-11.9-62.102-6.5-17.199-16.5-32.597-29.6-45.398-12.802-13-28.302-23.102-45.302-29.5-16.296-6.3-34.898-10.7-62.097-11.898C334.648.3 325.949 0 256.449 0s-78.199.3-105.5 1.5c-27.199 1.2-45.898 5.602-62.097 11.898-17.204 6.5-32.602 16.5-45.403 29.602-13 12.8-23.097 28.3-29.5 45.3-6.3 16.302-10.699 34.9-11.898 62.098C.75 177.801.449 186.5.449 256s.301 78.2 1.5 105.5c1.2 27.2 5.602 45.898 11.903 62.102 6.5 17.199 16.597 32.597 29.597 45.398 12.801 13 28.301 23.102 45.301 29.5 16.3 6.3 34.898 10.7 62.102 11.898 27.296 1.204 36 1.5 105.5 1.5s78.199-.296 105.5-1.5c27.199-1.199 45.898-5.597 62.097-11.898a130.934 130.934 0 0 0 74.903-74.898c6.296-16.301 10.699-34.903 11.898-62.102 1.2-27.3 1.5-36 1.5-105.5s-.102-78.2-1.3-105.5zm-46.098 209c-1.102 25-5.301 38.5-8.801 47.5-8.602 22.3-26.301 40-48.602 48.602-9 3.5-22.597 7.699-47.5 8.796-27 1.204-35.097 1.5-103.398 1.5s-76.5-.296-103.403-1.5c-25-1.097-38.5-5.296-47.5-8.796C94.551 451.5 84.45 445 76.25 436.5c-8.5-8.3-15-18.3-19.102-29.398-3.5-9-7.699-22.602-8.796-47.5-1.204-27-1.5-35.102-1.5-103.403s.296-76.5 1.5-103.398c1.097-25 5.296-38.5 8.796-47.5C61.25 94.199 67.75 84.1 76.352 75.898c8.296-8.5 18.296-15 29.398-19.097 9-3.5 22.602-7.7 47.5-8.801 27-1.2 35.102-1.5 103.398-1.5 68.403 0 76.5.3 103.403 1.5 25 1.102 38.5 5.3 47.5 8.8 11.097 4.098 21.199 10.598 29.398 19.098 8.5 8.301 15 18.301 19.102 29.403 3.5 9 7.699 22.597 8.8 47.5 1.2 27 1.5 35.097 1.5 103.398s-.3 76.301-1.5 103.301zm0 0"
                        fill="#ffffff"
                        opacity="1"
                        data-original="#000000"
                      ></path>
                      <path
                        d="M256.45 124.5c-72.598 0-131.5 58.898-131.5 131.5s58.902 131.5 131.5 131.5c72.6 0 131.5-58.898 131.5-131.5s-58.9-131.5-131.5-131.5zm0 216.8c-47.098 0-85.302-38.198-85.302-85.3s38.204-85.3 85.301-85.3c47.102 0 85.301 38.198 85.301 85.3s-38.2 85.3-85.3 85.3zM423.852 119.3c0 16.954-13.747 30.7-30.704 30.7-16.953 0-30.699-13.746-30.699-30.7 0-16.956 13.746-30.698 30.7-30.698 16.956 0 30.703 13.742 30.703 30.699zm0 0"
                        fill="#ffffff"
                        opacity="1"
                        data-original="#000000"
                      ></path>
                    </g>
                  </svg>
                </a>
                <a href="#">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="512"
                    height="512"
                    viewBox="0 0 155.139 155.139"
                  >
                    <g>
                      <path
                        d="M89.584 155.139V84.378h23.742l3.562-27.585H89.584V39.184c0-7.984 2.208-13.425 13.67-13.425l14.595-.006V1.08C115.325.752 106.661 0 96.577 0 75.52 0 61.104 12.853 61.104 36.452v20.341H37.29v27.585h23.814v70.761h28.48z"
                        fill="#ffffff"
                        data-original="#010002"
                        opacity="1"
                      ></path>
                    </g>
                  </svg>
                </a>
                <a href="#">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="512"
                    height="512"
                    viewBox="0 0 1226.37 1226.37"
                  >
                    <g>
                      <path
                        d="M727.348 519.284 1174.075 0h-105.86L680.322 450.887 370.513 0H13.185l468.492 681.821L13.185 1226.37h105.866l409.625-476.152 327.181 476.152h357.328L727.322 519.284zM582.35 687.828l-47.468-67.894-377.686-540.24H319.8l304.797 435.991 47.468 67.894 396.2 566.721H905.661L582.35 687.854z"
                        fill="#ffffff"
                        opacity="1"
                        data-original="#000000"
                      ></path>
                    </g>
                  </svg>
                </a>
              </div>
            </div>

            <div className="footer-column">
              <h3 className="column-title">Quick link</h3>
              <ul>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <a href="#services" onClick={handleServicesClick}>
                    Our Services
                  </a>
                </li>

                <li>
                  <Link to="/blog">Blog</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
                <li>
                  <Link to="/terms-and-condition">Terms and Conditions</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="column-title">Services</h3>
              <ul>
                <li>
                  <Link to="/mobile-app-development">Mobile App Development</Link>
                </li>
                <li>
                  <Link to="/web-development">Web Development</Link>
                </li>
                <li>
                  <Link to="/ui-ux">UI/UX Design</Link>
                </li>
                <li>
                  <Link to="/e-commerce-development">
                    E-Commerce Development
                  </Link>
                </li>
                <li>
                  <Link to="/api-development">API Development</Link>
                </li>
                <li>
                  <Link to="/crm-development">CRM Development</Link>
                </li>
                <li>
                  <Link to="/cloud-solutions">Cloud Solutions</Link>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="column-title">Contact Us</h3>
              <ul className="contact-info">
                <li>
                  <a href="tel:91 7821012121">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="512"
                      height="512"
                      viewBox="0 0 32 32"
                    >
                      <g>
                        <path
                          d="M22.005 23.914c.417.685.542 1.49.352 2.269a2.982 2.982 0 0 1-1.356 1.854l-2.484 1.512a2.979 2.979 0 0 1-1.551.436c-.484 0-.972-.117-1.425-.353-5.216-2.705-8.194-6.722-9.505-8.875C3.131 15.985 2.521 11.283 2.52 8.18c0-1.046.538-2 1.44-2.55l2.485-1.512a2.975 2.975 0 0 1 2.269-.352c.778.189 1.437.67 1.853 1.355l1.56 2.562a3.004 3.004 0 0 1-1.003 4.123l-1.287.783c-.386.235-.574.707-.445 1.121a17.51 17.51 0 0 0 4.44 7.298.984.984 0 0 0 1.205.124l1.286-.783a3.003 3.003 0 0 1 4.123 1.002l1.56 2.563zm-5.916-12.02a4.005 4.005 0 0 1 3.343 4.563 1 1 0 1 0 1.977.305 6.007 6.007 0 0 0-5.014-6.845 1 1 0 0 0-.306 1.976zm.915-5.93a1.001 1.001 0 0 0-.305 1.977c2.112.326 3.97 1.455 5.233 3.179s1.779 3.836 1.453 5.948a1.001 1.001 0 0 0 1.977.305c.408-2.64-.237-5.28-1.816-7.435s-3.902-3.565-6.542-3.973zm.61-3.953a1.003 1.003 0 0 0-1.141.836c-.084.545.29 1.056.836 1.141 6.539 1.009 11.038 7.15 10.029 13.69a1.001 1.001 0 0 0 1.977.305c1.178-7.629-4.071-14.793-11.701-15.971z"
                          fill="#ffffff"
                          opacity="1"
                          data-original="#000000"
                        ></path>
                      </g>
                    </svg>
                  </a>{" "}
                  Phone: <a href="tel:91 7821012121">+91 7821012121</a>
                </li>
                <li>
                  <a href="mailto:radhe@hopewebsolution.com">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="512"
                      height="512"
                      viewBox="0 0 512 512"
                    >
                      <g>
                        <path
                          d="M467 76H45C20.137 76 0 96.262 0 121v270c0 24.885 20.285 45 45 45h422c24.655 0 45-20.03 45-45V121c0-24.694-20.057-45-45-45zm-6.302 30L287.82 277.967c-8.5 8.5-19.8 13.18-31.82 13.18s-23.32-4.681-31.848-13.208L51.302 106h409.396zM30 384.894V127.125L159.638 256.08 30 384.894zM51.321 406l129.587-128.763 22.059 21.943c14.166 14.166 33 21.967 53.033 21.967s38.867-7.801 53.005-21.939l22.087-21.971L460.679 406H51.321zM482 384.894 352.362 256.08 482 127.125v257.769z"
                          fill="#ffffff"
                          opacity="1"
                          data-original="#000000"
                        ></path>
                      </g>
                    </svg>
                  </a>{" "}
                  Email:{" "}
                  <a href="mailto:radhe@hopewebsolution.com">radhe@hopewebsolution.com</a>
                </li>
                <li>
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=Office+No.+325,+Third+Floor,+Krishna+Square+Subhash+Nagar,+Shastri+Nagar,+Jaipur,+Rajasthan+302016"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="512"
                      height="512"
                      viewBox="0 0 512 512"
                    >
                      <g>
                        <path
                          d="M256 68.5c-82 0-149.3 67.2-150 149.8-.8 101.4 132.2 215.9 137.8 220.7 3.5 3 7.8 4.5 12.2 4.5 4.3 0 8.6-1.5 12.1-4.5 5.6-4.8 137.9-118.2 137.9-220.5 0-82.7-67.3-150-150-150zm0 37.5c62 0 112.5 50.5 112.5 112.5 0 31.8-17.3 66.5-39 97.6-44.2-29.9-102.6-29.9-146.8-.1-22.3-32-39.4-66.8-39.2-97.3.5-62.2 51-112.7 112.5-112.7z"
                          fill="#ffffff"
                          opacity="1"
                          data-original="#000000"
                        ></path>
                        <path
                          d="M256 256c31 0 56.3-25.2 56.3-56.3S287 143.5 256 143.5s-56.3 25.2-56.3 56.3S225 256 256 256z"
                          fill="#ffffff"
                          opacity="1"
                          data-original="#000000"
                        ></path>
                      </g>
                    </svg>
                  </a>
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=Office+No.+325,+Third+Floor,+Krishna+Square+Subhash+Nagar,+Shastri+Nagar,+Jaipur,+Rajasthan+302016"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Office No. 325, Third Floor, Krishna Square Subhash Nagar,
                    Shastri Nagar, Jaipur, Rajasthan 302016
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">©2026 HWS. All rights reserved</div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
